import navTab from "./navTab.vue"
export default navTab



// WEBPACK FOOTER //
// ./src/layout/navTab/index.js